import React, { useContext, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import CheckoutContext from "../contexts/CheckoutContext";
import StatusScreenWrapper from "../components/StatusScreenWrapper";
import MainTitle from "../components/MainTitle";
import WaMeLink from "../components/WaMeLink";

const PaymentFailure = () => {

    const location = useLocation();

    const navigate = useNavigate();

    const { clientData } = useContext(CheckoutContext);
    const [renderResult, setRenderResult] = useState(false);

    // Esta función te ayuda a extraer los parámetros de la URL
    const getQueryParams = (search) => {
        return new URLSearchParams(search);
    };

    const queryParams = getQueryParams(location.search);

    // Ejemplo de cómo obtener algunos parámetros
    // const collectionId = queryParams.get("collection_id");
    const paymentId = queryParams.get("payment_id");
    console.log("Payment ID", paymentId);
    // const status = queryParams.get("status");
    // const externalReference = queryParams.get("external_reference");

    return (
        <div className="min-h-screen bg-[#f7f4ef] pb-10">

            {/* Header */}
            <MainTitle />

            {/* Comprobante de Mercado Pago */}
            <StatusScreenWrapper payment_id={paymentId} setRenderResult={setRenderResult}/>

            {/* Aviso de rechazo */}
            <div className="mx-3 mt-4 rounded-2xl overflow-hidden bg-white border border-gray-100 shadow-sm">
                <div className="px-4 py-3 flex items-center gap-2 bg-[#f7f4ef] border-b border-gray-100">
                    <svg className="w-4 h-4 text-amber-500 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
                    </svg>
                    <p className="text-sm font-semibold text-[#2a1419]">Pago rechazado</p>
                </div>
                <div className="px-4 py-3">
                    <p className="text-[13px] text-[#2a1419] leading-relaxed">
                        {clientData.name}, su pedido no será despachado, el pago fue rechazado.
                    </p>
                    <p className="text-[12px] text-gray-400 mt-1">Por favor inténtelo nuevamente.</p>
                </div>
            </div>

            {/* Reintentar */}
            <div className="px-4 mt-4">
                <button
                    onClick={() => navigate("/checkout/info")}
                    className="w-full py-3 rounded-xl text-sm font-semibold bg-[#8c1d2f] hover:bg-[#a82a42] active:scale-[0.98] text-[#f5f0e8] shadow-md shadow-[#8c1d2f]/20 transition-all duration-150"
                >
                    Volver a intentar
                </button>
            </div>

            <WaMeLink />
        </div>
    );
}

export default PaymentFailure;
